import {getInitParam, InitParam, Line2, MPos, PlaceMeta, SegmentLine, Vec2} from "@3dcalc/3dpClient";

const mapVec2: Vec2[] = []
const line2: Line2 = [[0,0],[0,0]]
const mapVec3:MPos[] = []
const segmentLines:SegmentLine[] = []
const placeMeta: PlaceMeta = {
    h: 0, l: 0, p: {b: [0,0], t: [0,0]}, w: 0
};

type ReadyCallback = () => void
const callbacks: ReadyCallback[] = []


type CarportInitParam = InitParam & {
    e: { left: number; right: number; front: number; back: number }
    block: { w: number; l: number; h: number }
}

export let isReady = false

export let initParam: CarportInitParam = {
    ...getInitParam(),
    e: { left: 0, right: 0, front: 0, back: 0 },
    block: { w: 0, l: 0, h: 0 },
}

export function onReady(cb: ReadyCallback) {
    if (isReady) cb()  // уже готов — вызываем сразу
    else callbacks.push(cb)
}

export function setReady(config: InitParam) {
    Object.assign(initParam, config)
    isReady = true
    callbacks.forEach(cb => cb())
    callbacks.length = 0
}

export const CP = {
    maps: {
        pillar: {
            line: mapVec2,
            map: mapVec3,
            lineCenteredCut: mapVec2,
            lineCut: mapVec2,
            lineCentered: mapVec2
        },
        f1: {
            lineCut: mapVec2,
        },
        block: {
            line: mapVec2,
        },
        harness: {
            segments: segmentLines,
        },
        f2: {
            param: placeMeta,
        },
        f3: {
            diagonal: line2,
        },
        f4: {
            point: [0, 0]
        },
        f6: {
            point: [0, 0]
        },
        rafter: {
            lineCut: mapVec2,
            map: mapVec2,
            hGash: 0,
            l: {
                left: 0,
                right: 0,
            },
            shiftBottom: {
                left: 0,
                right: 0,
            },
            hCut: 0,
            mapCentered: mapVec2
        }
    },
    gash: {
        simple: 0.02,
        cut: 0.05,
        rafterAngle: 0,
    },
}


//
// export const initParam = {
//     sizes: {w: 5.7, h: 2.7, l: 10},
//     e: {
//         left: 0.35,
//         right: 0.35,
//         front: 0.35,
//         back: 0.35
//     },
//     a: 20,
//     block: {
//         l: 0,
//         h: 0,
//         w: 2.6,
//     },
//     maxSize: {
//         l: 9,
//         h: 3.5,
//         w: 9,
//         a: 35,
//         ref: 1,
//         reb: 1,
//         rel: 1,
//         rer: 1,
//         block: {
//             l: 0,
//             h: 0,
//             w: 4.5,
//         },
//     },
//     minSize: {
//         l: 2.5,
//         h: 2,
//         w: 3.5,
//         a: 12,
//         ref: 0.01,
//         reb: 0.01,
//         rel: 0.01,
//         rer: 0.01,
//         block: {
//             l: 0,
//             h: 0,
//             w: 1.5,
//         },
//     },
//     setting: {
//         pillarMaxSpan: 4.5,
//         rafterMaxSpan: 0.6,
//         sheathingSpan: 0.001,
//     },
//     elementData: {
//         pillar: {
//             sizeBoard: {w: 0.2, h: 0.2, l: 0, maxL: 12, minL: 1.5}
//         },
//         pk: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         block1: {
//             sizeBoard: {w: 0.088, h: 0.042, l: 0, maxL: 5.8, minL: 1.5}
//         },
//         cladding: {
//             sizeBoard: {w: 0.14, h: 0.015, l: 0, maxL: 5.8, minL: 1.5}
//         },
//         harness: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f1: {
//             sizeBoard: {w: 0.14, h: 0.2, l: 0, maxL: 12, minL: 1.5}
//         },
//         f2: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f3: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f4: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f5: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f6: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         f7: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         rafter: {
//             sizeBoard: {w: 0.042, h: 0.185, l: 0, maxL: 9, minL: 1.5}
//         },
//         ridge: {
//             sizeBoard: {w: 0.14, h: 0.14, l: 0, maxL: 12, minL: 1.5}
//         },
//         sheathing: {
//             sizeBoard: {w: 0.14, h: 0.018, l: 0, maxL: 6, minL: 1.5}
//         },
//     },
//     maps: {
//         pillar: {
//             line: mapVec2,
//             map: mapVec3,
//             lineCenteredCut: mapVec2,
//             lineCut: mapVec2,
//             lineCentered: mapVec2
//         },
//         f1: {
//             lineCut: mapVec2,
//         },
//         block: {
//             line: mapVec2,
//         },
//         harness: {
//             segments: segmentLines,
//         },
//         f2: {
//             param: placeMeta,
//         },
//         f3: {
//             diagonal: line2,
//         },
//         f4: {
//             point: [0, 0]
//         },
//         f6: {
//             point: [0, 0]
//         },
//         rafter: {
//             lineCut: mapVec2,
//             map: mapVec2,
//             hGash: 0,
//             l: {
//                 left: 0,
//                 right: 0,
//             },
//             shiftBottom: {
//                 left: 0,
//                 right: 0,
//             },
//             hCut: 0,
//             mapCentered: mapVec2
//         }
//     },
//     gash: {
//         simple: 0.02,
//         cut: 0.05,
//         rafterAngle: 0,
//     },
//     angles: {
//         f4: 20,
//         f6: 20,
//     }
// }


export function initializate() {
    initParam.gash.cut = initParam.elementData.harness.sizeBoard.w - initParam.elementData.pillar.sizeBoard.h / 2
}
